<template>
  <b-modal id="error-modal" :visible="visible" title="Error" ok-only @hidden="hide">
    <p>
      {{errorMessage}}
    </p>
  </b-modal>
</template>

<script>

import {mapState} from "vuex";

export default {
  computed: mapState('errors', ["visible", "errorMessage"]),
  methods: {
    hide () {
      this.$store.commit('errors/resetMessage')
      this.$store.commit('errors/setVisibility', false)
    }
  }
}
</script>